import React, { useEffect, useState } from 'react';
import './App.css';
import { FaWhatsapp, FaInstagram, FaFacebook } from 'react-icons/fa';
import pt from './locales/pt.json';
import en from './locales/en.json';

const translations = { pt, en };

function getFromPath(obj, path) {
  return path.split('.').reduce((acc, p) => (acc && acc[p] ? acc[p] : ''), obj) || '';
}

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const paramLang = urlParams.get('lang');
  const initial = paramLang || localStorage.getItem('okami_lang') || 'pt';
  const [lang, setLang] = useState(initial);

  useEffect(() => {
    // persist and set document lang
    localStorage.setItem('okami_lang', lang);
    document.documentElement.lang = lang === 'pt' ? 'pt-BR' : 'en';
  }, [lang]);

  function t(path) {
    return getFromPath(translations[lang] || {}, path) || '';
  }

  function changeLang(newLang) {
    setLang(newLang);
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="brand">
          <img src="/img/bushin.png" alt="Ōkami Dōjō Logo" className="logo" />
          <div>
            <h1 className="site-title">{t('title') || 'Bujinkan Ōkami Dōjō'}</h1>
          </div>
        </div>

        <nav className="nav">
          <a href="/">Home</a>
          <a href="/blog">Blog</a>
        </nav>

        <div className="lang-switch">
          <button id="btn-pt" className={`lang ${lang === 'pt' ? 'active' : ''}`} onClick={() => changeLang('pt')}>PT</button>
          <button id="btn-en" className={`lang ${lang === 'en' ? 'active' : ''}`} onClick={() => changeLang('en')}>EN</button>
        </div>
      </header>
      <main>
        <section id="about">
          <h2>{t('about.title') || 'Sobre a Bujinkan'}</h2>
          <p>{t('about.p1')}</p>
          <p>{t('about.p2')}</p>
          <p>{t('about.p3')}</p>
          <p>{t('about.p4')}</p>
          <h2>{t('dojo.title') || 'Sobre o Dōjō'}</h2>
          <p>{t('dojo.p1')}</p>
          <p>{t('dojo.p2')}</p>
          <p>{t('dojo.p3')}</p>
        </section>
        <section id="leader">
          <h2>{t('leader.title') || 'Professor'}</h2>
          <div style={{marginTop:'1rem', textAlign:'left'}}>
            <p>{t('leader.bio1')}</p>
            <p>{t('leader.bio2')}</p>
            <p>{t('leader.bio3')}</p>
            <p>{t('leader.bio4')}</p>
            <p>{t('leader.bio5')}</p>
          </div>
        </section>
        <section id="schedule">
          <h2>{t('schedule.title') || 'Horários'}</h2>
          <ul>
            <li>{t('schedule.mon') || 'Segunda: 21:00 - 22:00'}</li>
            <li>{t('schedule.wed') || 'Quarta: 21:00 - 22:00'}</li>
            <li>{t('schedule.fri') || 'Sexta: 20:00 - 21:00'}</li>
          </ul>
        </section>
        <section id="location">
          <h2>{t('location.title') || 'Localização'}</h2>
          <p>Centro Comercial Marlim Azul Jardim - R. Eugenílio Ramos, 665<br/>Jardim da Penha, Vitória - ES<br/>29060-130</p>
          <div style={{display:'flex',justifyContent:'center',margin:'16px 0'}}>
            <iframe title="Centro de Lutas de Jardim da Penha" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.3294739438306!2d-40.2974147!3d-20.2866252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb817f748182711%3A0x5d5d1b6351e69044!2sCENTRO%20DE%20LUTAS%20JARDIM%20DA%20PENHA!5e0!3m2!1spt-BR!2sbr!4v1752240741478!5m2!1spt-BR!2sbr" width="100%" height="300" style={{border:0, borderRadius:'8px', maxWidth:'500px'}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </section>
        <section id="trial">
          <h2>{t('trial.title') || 'Agende sua aula experimental'}</h2>
          <form onSubmit={e => {
            e.preventDefault();
            const name = e.target[0].value;
            const email = e.target[1].value;
            const horario = e.target[2].value;

            const mensagem = `${lang === 'pt' ? 'Olá! Quero agendar uma aula experimental no Ōkami Dōjō.\n' : 'Hello! I\'d like to book a trial class.\n'}Nome: ${name}\nE-mail: ${email}\n${horario?'Horário desejado: '+horario:''}`;
            const encoded = encodeURIComponent(mensagem);

            window.open(`https://wa.me/5527988848526?text=${encoded}`, '_blank'); }}
          style={{marginTop:'1rem'}}>
            <input id="name" type="text" placeholder={t('trial.namePlaceholder') || 'Nome'} required style={{padding:'8px',marginRight:'8px'}} />
            <input id="email" type="email" placeholder={t('trial.emailPlaceholder') || 'E-mail'} required style={{padding:'8px',marginRight:'8px'}} />
            <select style={{ padding: '8px', marginRight: '8px' }}>
              <option value="">Selecione o horário</option>
              <option value="Segunda, às 21h">Segunda, às 21h</option>
              <option value="Quarta, às 21h">Quarta, às 21h</option>
              <option value="Sexta, às 20h">Sexta, às 20h</option>
            </select>
            <button type="submit" style={{padding:'8px 16px',background:'#b71c1c',color:'#fff',border:'none',borderRadius:'4px'}}>{t('trial.bookButton') || 'Agende via WhatsApp'}</button>
          </form>
        </section>
        <section id="social">
          <h2>{t('social.title') || 'Redes Sociais'}</h2>
          <div style={{display:'flex',gap:'24px',justifyContent:'center',marginTop:'12px'}}>
            <a id="whatsapp-link" href="https://wa.me/5527988848526" target="_blank" rel="noopener noreferrer" style={{color:'#25D366',fontSize:'2rem'}} title="WhatsApp"><FaWhatsapp /></a>
            <a id="instagram-link" href="https://instagram.com/bujinkanookamidojo" target="_blank" rel="noopener noreferrer" style={{color:'#E1306C',fontSize:'2rem'}} title="Instagram"><FaInstagram /></a>
            <a id="facebook-link" href="https://www.facebook.com/profile.php?id=61559180380677" target="_blank" rel="noopener noreferrer" style={{color:'#1877F3',fontSize:'2rem'}} title="Facebook"><FaFacebook /></a>
          </div>
        </section>
      </main>
      <footer>
        <p>&copy; 2025 Okami Dojo. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
